import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { environment } from 'src/environments/environment';
import { SharedService } from '../dashboard/shared.service';

@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.css']
})
export class ProjectComponent implements OnInit {

  base_url=environment.baseUrl;
  projects = [] as any;
  currentUser:any;
  bgclass = 'imagebg-1';

  public projectForm!: FormGroup;
  public new = false;

  public project:any;
  public loading = false;

  constructor(
    private httpclient: HttpClient,
    private router: Router,
    private sharedService: SharedService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {

    this.bgSwitcher();

    this.new = false;
    this.loading = false;

    this.currentUser = this.sharedService.getUser();

    this.projectForm = this.formBuilder.group({
      _id: [null],
      name: ['',Validators.required],
      type: ['', Validators.required],
      property_type: ['',Validators.required],
      base_price: ['',Validators.required],
      gst: ['',Validators.required],
      edc: ['', Validators.required],
      plc: this.formBuilder.array([this.addPlcGroup()]),
    })

    this.httpclient.get(this.base_url+'projects').subscribe((response:any)=>{
      if(this.currentUser.role === 'admin'){
        this.projects=response.data;
      }else{
        response.data.forEach(element => {
          if(element._id === this.currentUser.project){
            this.projects.push(element)
          }
        });
      }
      console.log(this.currentUser)
    },
    (error)=>{
      console.log(error);
    })

  }

  bgSwitcher(){
    setInterval(()=>{
      if(this.bgclass === 'imagebg-1'){
        this.bgclass = 'imagebg-2'
      }else{
        this.bgclass = 'imagebg-1'
      }
    }, 3500);
  }

  projectInitializer(project:any){
    this.sharedService.setProject(project);
    if(this.currentUser.role === 'dataentry'){
      this.router.navigate(['dashboard/leads']);
    }else if(this.currentUser.role === 'sales'){
      this.router.navigate(['dashboard/leads/manage']);
    }else{
      this.router.navigate(['/dashboard']);
    }
  }

  newProject(){
    this.new = true;
  }

  cancel(){
    this.new = false;
    this.loading = false;
    this.projectForm.reset();
  }

  addPlcGroup(){
    return this.formBuilder.group({
      plc_name: [],
      price: []
    })
  }

  get plcArray(){
    return <FormArray>this.projectForm.get('plc')
  }

  addPlc(){
    this.plcArray.push(this.addPlcGroup())
  }

  removePlc(index:any){
    this.plcArray.removeAt(index);
  }


  onSubmit(){
    if(this.projectForm.invalid){
      return;
    }else{
      this.loading = true;
      this.sharedService.createProject(this.projectForm.value).subscribe((data:any)=>{
        this.Toast.fire({
          title: 'Updated!',
          text: 'Updated successfully',
          icon: 'success'
        })
        this.ngOnInit();
      }, (error)=>{
        this.loading = false;
        this.Toast.fire({
          title: 'Error!',
          text: error.error.message,
          icon: 'error'
        })
      })
    }
  }

  Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

}
